<script setup lang="tsx">
const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: "#666666"
  }
);
</script>

<template>
  <!-- origin viewBox : x y width height : 0 0 24 24 , 目前 viewBox 是为了切除四周多余空白 -->
  <!-- 不设置 width height , 自适应父元素 -->
  <svg
    viewBox="6 6 12 12"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.22785 6.22781C6.53159 5.92407 7.02405 5.92407 7.32779 6.22781L17.7722 16.6722C18.0759 16.976 18.0759 17.4685 17.7722 17.7722C17.4685 18.0759 16.976 18.0759 16.6723 17.7722L6.22785 7.32775C5.92411 7.02401 5.92411 6.53155 6.22785 6.22781Z"
      :fill="props.color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7722 6.22781C18.0759 6.53155 18.0759 7.02401 17.7722 7.32775L7.32775 17.7722C7.02401 18.0759 6.53155 18.0759 6.22781 17.7722C5.92406 17.4685 5.92407 16.976 6.22781 16.6722L16.6722 6.22781C16.976 5.92406 17.4684 5.92406 17.7722 6.22781Z"
      :fill="props.color"
    />
  </svg>
</template>
